/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = require("./Icons");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ToggleButton = function ToggleButton(_ref) {
  var onToggle = _ref.onToggle,
    className = _ref.className,
    toggleIcon = _ref.toggleIcon,
    size = _ref.size,
    expanded = _ref.expanded;
  var toggleIconProps = {
    className: className,
    size: size,
    expanded: expanded,
    onClick: function onClick(event) {
      event.preventDefault();
      onToggle();
    }
  };
  var toggleButtonEl;
  if (toggleIcon) {
    var params = {
      onToggle: onToggle,
      expanded: expanded,
      domProps: toggleIconProps
    };
    toggleButtonEl = typeof toggleIcon === 'function' ? toggleIcon(params) : toggleIcon;
  }
  if (toggleButtonEl === true || toggleButtonEl == undefined) {
    toggleButtonEl = _react.default.createElement(_Icons.ToggleIcon, _objectSpread({}, toggleIconProps));
  }
  return toggleButtonEl;
};
ToggleButton.defaultProps = {
  size: 10
};
ToggleButton.propTypes = {
  expanded: _propTypes.default.bool,
  size: _propTypes.default.number
};
var _default = ToggleButton;
exports.default = _default;